import { lookupTableReducer } from 'Modules/core/redux';

import { configActions } from './actions';


const actionLookup = {
    [`${configActions.set}`]: (state, config) => ({
        ...state,
        ...config,
    }),
};

export const config = lookupTableReducer({}, actionLookup);
